// removed by extract-text-webpack-plugin
module.exports = {"table_ui":"Tt3z-","table_add":"_3kY_v","table_delete":"_2higQ","root":"_3rL3p","headline":"_2S-0v","headline_cont":"_1pkCR","headline__btn":"_1RUAK _12TwT _3gxMh","headline__icon":"_2kbEU","table":"_16Jzu _300jB","delete":"_3vX9P _2higQ"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/groups/Groups.css
// module id = 392
// module chunks = 0